import type { ReactNode } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

type Props = {
  title: string
  children: ReactNode
}

export const FilterField = ({ title, children }: Props) => {
  return (
    <Field>
      <Title>{title}</Title>
      <FilterList>{children}</FilterList>
    </Field>
  )
}

const Field = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`

const Title = styled.div`
  font-size: 16px;
  line-height: 27px;
  color: ${theme.colors.textTitle};
  width: 48px;
  margin-right: 80px;

  @media screen and (max-width: 1047px) {
    font-size: 14px;
    line-height: 24px;
    margin: 0;
    width: auto;
  }
`

const FilterList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  flex: 1;
`
